export const SKILL_FIT_TRACK_LOCATION = 'career-qualifications';

export const SKILL_FIT_TOGGLE_TRACK_CLICK = 'Career Skill Fit Toggle Clicked';
export const SKILL_FIT_SKILL_TRACK_CLICK = 'Career Skill Fit Skill Clicked';
